import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
// import { StagewiseToolbar } from "@stagewise/toolbar-react";
// import ReactPlugin from "@stagewise-plugins/react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ProtectedRoute, PublicRoute } from "./components/ProtectedRoute";
// import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import AddUserPage from "./admin_dashboard/AddUserPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import HomePageEight from "./pages/HomePageEight";
import HomePageNine from "./pages/HomePageNine";
import HomePageTen from "./pages/HomePageTen";
import HomePageEleven from "./pages/HomePageEleven";
import GalleryGridPage from "./pages/GalleryGridPage";
import GalleryMasonryPage from "./pages/GalleryMasonryPage";
import GalleryHoverPage from "./pages/GalleryHoverPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import AddBlogPage from "./pages/AddBlogPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import UserDashboard from "./pages/UserDashboard";
import SecuritySettingsPage from "./admin_dashboard/pages/SecuritySettingsPage";
import SystemLogsPage from "./admin_dashboard/pages/SystemLogsPage";
import MaintenancePage from "./pages/MaintenancePage";
import CustomerAddPage from "./customers/CustomerAddPage";
import CustomerProfilePage from "./customers/CustomerProfilePage";
import BlankPagePage from "./pages/BlankPagePage";
import CustomersListPage from "./customers/CustomersListPage";

// Import license components
import LicenseListPage from "./licenses/LicenseListPage";
import LicenseFormPage from "./licenses/LicenseFormPage";
import LicenseDetailPage from "./licenses/LicenseDetailPage";
import RevokedLicensesListPage from './licenses/RevokedLicensesListPage';
import MacRequestListPage from "./licenses/MacRequestListPage";
import LicenseExpiryReport from "./reports/LicenseExpiryReport";
import InactiveLicensesReport from "./reports/InactiveLicensesReport";
import UsageAnalyticsReport from "./reports/UsageAnalyticsReport";
import ValidationFailuresReport from "./admin_dashboard/ValidationFailuresReport";
import EditUserPage from "./pages/EditUserPage";
// In your route or component:

// Import new login components
import Login from "./login/Login";
import SignUp from "./login/SignUp";
import ForgotPassword from "./login/ForgotPassword";

// Import admin dashboard components
import AdminDashboard from "./admin_dashboard/AdminDashboard";
// import AdminUsersList from "./admin_dashboard/AdminUsersList";
import UsersPage from "./admin_dashboard/UsersPage";
import GeneralSettingsPage from "./admin_dashboard/GeneralSettingsPage";
import AdminPage from "./admin_dashboard/AdminPage";

// import terms and conditions components
import TermsAndConditionsPage from "./components/Terms-and-Conditions/TermsAndConditionsPage";

function AppContent() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Determine the dashboard path based on user role
  const getDashboardPath = () => {
    if (!isAuthenticated) return '/sign-in';
    const userRole = user?.role?.toLowerCase();
    if (userRole === 'superuser') return '/dashboard';
    if (userRole === 'admin') return '/admin-dashboard';
    return '/dashboard'; // Fallback for other roles
  };

  return (
    <Routes>
      <Route path="/" element={<Navigate to={getDashboardPath()} replace />} />
      <Route path="/sign-in" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      <Route path="/sign-up" element={
        <PublicRoute>
          <SignUp />
        </PublicRoute>
      } />
      <Route path="/forgot-password" element={
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      } />
      {/* Dashboard route with role-based redirection */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          {user?.role?.toLowerCase() === 'user' ? <Navigate to="/user-dashboard" replace /> : 
           user?.role?.toLowerCase() === 'admin' || user?.role?.toLowerCase() === 'superuser' ? 
           <Navigate to="/admin-dashboard" replace /> :
           <Navigate to="/access-denied" replace />}
        </ProtectedRoute>
      } />
      
      {/* Specific dashboard routes */}
      <Route path="/admin-dashboard" element={
        <ProtectedRoute requiredRoles={['admin', 'superuser']}>
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/user-dashboard" element={
        <ProtectedRoute requiredRoles={['user']}>
          <UserDashboard />
        </ProtectedRoute>
      } />
      {/* Add other protected routes here */}
        {/* Set Login as the default route */}
        {/* Keep existing routes but wrap them in ProtectedRoute as needed */}
        
        {/* Admin specific routes - these must come BEFORE the wildcard route */}
        <Route exact path="/admin/users" element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <UsersPage />
          </ProtectedRoute>
        } />
        <Route exact path="/admin/users/admins" element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <AdminPage />
          </ProtectedRoute>
        } />
        <Route exact path="/admin/users/add" element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <AddUserPage />
          </ProtectedRoute>
        } />
        <Route exact path="/admin/users/edit/:id" element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <EditUserPage />
          </ProtectedRoute>
        } />
        <Route exact path="/admin/settings/general" element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <GeneralSettingsPage />
          </ProtectedRoute>
        } />
        <Route exact path="/admin/settings/security" element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <SecuritySettingsPage />
          </ProtectedRoute>
        } />
        <Route exact path="/admin/settings/logs" element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <SystemLogsPage />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/customers' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser', 'user']}>
            <CustomersListPage />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/customers/create' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <CustomerAddPage />
          </ProtectedRoute>
        } />
        <Route path='/admin/customers/:id' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser', 'user']}>
            <CustomerProfilePage />
          </ProtectedRoute>
        } />
        
        {/* License Management Routes */}
        <Route exact path='/admin/licenses' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser', 'user']}>
            <LicenseListPage />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/licenses/create' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <LicenseFormPage />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/terms' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <TermsAndConditionsPage/>
          </ProtectedRoute>
        } />
        <Route exact path='/admin/licenses/:id' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <LicenseDetailPage />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/licenses/:id/edit' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <LicenseFormPage isEdit={true} />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/licenses/revoked' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser', 'user']}>
            <RevokedLicensesListPage />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/reports/license-expiry' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser', 'user']}>
            <LicenseExpiryReport />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/reports/validation' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <ValidationFailuresReport />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/reports/inactive' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <InactiveLicensesReport />
          </ProtectedRoute>
        } />
        <Route exact path='/admin/reports/analytics' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <UsageAnalyticsReport />
          </ProtectedRoute>
        } />
        
        {/* MAC Address Requests */}
        <Route exact path='/admin/mac-requests' element={
          <ProtectedRoute requiredRoles={['admin', 'superuser', 'user']}>
            <MacRequestListPage />
          </ProtectedRoute>
        } />
        
        {/* Admin wildcard route - this must come AFTER specific routes */}
        <Route path="/admin/*" element={
          <ProtectedRoute requiredRoles={['admin', 'superuser']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route exact path='/index-2' element={<HomePageTwo />} />
        <Route exact path='/index-3' element={<HomePageThree />} />
        <Route exact path='/index-4' element={<HomePageFour />} />
        <Route exact path='/index-5' element={<HomePageFive />} />
        <Route exact path='/index-6' element={<HomePageSix />} />
        <Route exact path='/index-7' element={<HomePageSeven />} />
        <Route exact path='/index-8' element={<HomePageEight />} />
        <Route exact path='/index-9' element={<HomePageNine />} />
        <Route exact path='/index-10' element={<HomePageTen />} />
        <Route exact path='/index-11' element={<HomePageEleven />} />

        {/* SL */}
        <Route exact path='/alert' element={<AlertPage />} />
        <Route exact path='/assign-role' element={<AssignRolePage />} />
        <Route exact path='/avatar' element={<AvatarPage />} />
        <Route exact path='/badges' element={<BadgesPage />} />
        <Route exact path='/button' element={<ButtonPage />} />
        <Route exact path='/calendar-main' element={<CalendarMainPage />} />
        <Route exact path='/calendar' element={<CalendarMainPage />} />
        <Route exact path='/card' element={<CardPage />} />
        <Route exact path='/carousel' element={<CarouselPage />} />
        <Route exact path='/chat-empty' element={<ChatEmptyPage />} />
        <Route exact path='/chat-message' element={<ChatMessagePage />} />
        <Route exact path='/chat-profile' element={<ChatProfilePage />} />
        <Route exact path='/code-generator' element={<CodeGeneratorPage />} />
        <Route
          exact
          path='/code-generator-new'
          element={<CodeGeneratorNewPage />}
        />
        <Route exact path='/colors' element={<ColorsPage />} />
        <Route exact path='/column-chart' element={<ColumnChartPage />} />
        <Route exact path='/company' element={<CompanyPage />} />
        <Route exact path='/currencies' element={<CurrenciesPage />} />
        <Route exact path='/dropdown' element={<DropdownPage />} />
        <Route exact path='/email' element={<EmailPage />} />
        <Route exact path='/faq' element={<FaqPage />} />
        <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
        <Route exact path='/form-layout' element={<FormLayoutPage />} />
        <Route exact path='/form-validation' element={<FormValidationPage />} />
        <Route exact path='/form' element={<FormPage />} />

        <Route exact path='/gallery' element={<GalleryPage />} />
        <Route exact path='/gallery-grid' element={<GalleryGridPage />} />
        <Route exact path='/gallery-masonry' element={<GalleryMasonryPage />} />
        <Route exact path='/gallery-hover' element={<GalleryHoverPage />} />

        <Route exact path='/blog' element={<BlogPage />} />
        <Route exact path='/blog-details' element={<BlogDetailsPage />} />
        <Route exact path='/add-blog' element={<AddBlogPage />} />

        <Route exact path='/testimonials' element={<TestimonialsPage />} />
        <Route exact path='/coming-soon' element={<ComingSoonPage />} />
        <Route exact path='/access-denied' element={<AccessDeniedPage />} />
        <Route exact path='/maintenance' element={<MaintenancePage />} />
        <Route exact path='/blank-page' element={<BlankPagePage />} />

        <Route exact path='/image-generator' element={<ImageGeneratorPage />} />
        <Route exact path='/image-upload' element={<ImageUploadPage />} />
        <Route exact path='/invoice-add' element={<InvoiceAddPage />} />
        <Route exact path='/invoice-edit' element={<InvoiceEditPage />} />
        <Route exact path='/invoice-list' element={<InvoiceListPage />} />
        <Route exact path='/invoice-preview' element={<InvoicePreviewPage />} />
        <Route exact path='/kanban' element={<KanbanPage />} />
        <Route exact path='/language' element={<LanguagePage />} />
        <Route exact path='/line-chart' element={<LineChartPage />} />
        <Route exact path='/list' element={<ListPage />} />
        <Route
          exact
          path='/marketplace-details'
          element={<MarketplaceDetailsPage />}
        />
        <Route exact path='/marketplace' element={<MarketplacePage />} />
        <Route
          exact
          path='/notification-alert'
          element={<NotificationAlertPage />}
        />
        <Route exact path='/notification' element={<NotificationPage />} />
        <Route exact path='/pagination' element={<PaginationPage />} />
        <Route exact path='/payment-gateway' element={<PaymentGatewayPage />} />
        <Route exact path='/pie-chart' element={<PieChartPage />} />
        <Route exact path='/portfolio' element={<PortfolioPage />} />
        <Route exact path='/pricing' element={<PricingPage />} />
        <Route exact path='/progress' element={<ProgressPage />} />
        <Route exact path='/radio' element={<RadioPage />} />
        <Route exact path='/role-access' element={<RoleAccessPage />} />
        <Route exact path='/sign-in' element={<Login />} />
        <Route exact path='/sign-up' element={<SignUp />} />
        <Route exact path='/forgot-password' element={<ForgotPassword />} />
        <Route exact path='/star-rating' element={<StarRatingPage />} />
        <Route exact path='/starred' element={<StarredPage />} />
        <Route exact path='/switch' element={<SwitchPage />} />
        <Route exact path='/table-basic' element={<TableBasicPage />} />
        <Route exact path='/table-data' element={<TableDataPage />} />
        <Route exact path='/tabs' element={<TabsPage />} />
        <Route exact path='/tags' element={<TagsPage />} />
        <Route exact path='/terms-condition' element={<TermsConditionPage />} />
        <Route
          exact
          path='/text-generator-new'
          element={<TextGeneratorNewPage />}
        />
        <Route exact path='/text-generator' element={<TextGeneratorPage />} />
        <Route exact path='/theme' element={<ThemePage />} />
        <Route exact path='/tooltip' element={<TooltipPage />} />
        <Route exact path='/typography' element={<TypographyPage />} />
        <Route exact path='/users-grid' element={<UsersGridPage />} />
        <Route exact path='/users-list' element={<UsersListPage />} />
        <Route exact path='/view-details' element={<ViewDetailsPage />} />
        <Route exact path='/video-generator' element={<VideoGeneratorPage />} />
        <Route exact path='/videos' element={<VideosPage />} />
        <Route exact path='/view-profile' element={<ViewProfilePage />} />
        <Route exact path='/voice-generator' element={<VoiceGeneratorPage />} />
        <Route exact path='/wallet' element={<WalletPage />} />
        <Route exact path='/widgets' element={<WidgetsPage />} />
        <Route exact path='/wizard' element={<WizardPage />} />

        <Route exact path='*' element={<ErrorPage />} />
      </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RouteScrollToTop />
        <AppContent />
        <ToastContainer 
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {/* {process.env.NODE_ENV === 'development' && (
          <StagewiseToolbar 
            config={{
              plugins: [ReactPlugin]
            }}
          />
        )} */}
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
